// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pricing .container-fluid .row .pricing-box {
  position: relative;
}
.pricing .container-fluid .row .pricing-box .card {
  padding: 15px;
  border: none;
  border-radius: 12px;
}
.pricing .container-fluid .row .pricing-box .card .card-body .card-title {
  color: var(--subscribe-text);
  font-weight: 600;
}
.pricing .container-fluid .row .pricing-box .card .card-body span {
  font-size: 2rem;
  color: var(--subscribe);
}
.pricing .container-fluid .row .pricing-box .card .card-body .text {
  font-size: 3rem;
  color: var(--subscribe);
}
.pricing .container-fluid .row .pricing-box .card .card-body .month {
  color: var(--subscribe);
}
.pricing .container-fluid .row .pricing-box .card .card-body .type {
  font-size: 1.2rem;
  color: var(--subscribe-text);
}
.pricing .container-fluid .row .pricing-box .card .card-body .active {
  color: var(--subscribe);
  background-color: transparent;
  font-size: 1.2rem !important;
  border: none;
}
.pricing .container-fluid .row .pricing-box .card .icon-option {
  position: absolute;
  right: 15px;
  top: 13%;
}
.pricing .container-fluid .row .pricing-box .card .ant-btn-default {
  border-color: transparent;
  color: var(--subscribe);
  background: #f6fafd;
  font-size: 1rem;
}
.pricing .container-fluid .row .pricing-box .card .button {
  transition: 0.5s ease;
}
.pricing .container-fluid .row .pricing-box .card .button:hover {
  transition: 0.5s ease;
  background: var(--subscribe);
  color: var(--white);
  border-color: var(--subscribe);
}
.pricing .container-fluid .row .pricing-box .card .button {
  margin-bottom: 10px;
}
.pricing .container-fluid .row .pricing-box .card {
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.1);
  transition: 0.4s box-shadow ease-out;
}
.pricing .container-fluid .row .pricing-box .card:hover {
  transition: 0.4s box-shadow ease-out;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}

.payment-card {
  min-height: 111px;
  cursor: pointer;
}
.payment-card.active {
  border-color: var(--primary);
}
.payment-card .payment-icon {
  width: 100%;
  min-height: 42px;
  font-size: 28px;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/components/subscriptions.scss"],"names":[],"mappings":"AAGM;EACE,kBAAA;AAFR;AAIQ;EACE,aAAA;EACA,YAAA;EACA,mBAAA;AAFV;AAIY;EACE,4BAAA;EACA,gBAAA;AAFd;AAKY;EACE,eAAA;EACA,uBAAA;AAHd;AAMY;EACE,eAAA;EACA,uBAAA;AAJd;AAOY;EACE,uBAAA;AALd;AAQY;EACE,iBAAA;EACA,4BAAA;AANd;AASY;EACE,uBAAA;EACA,6BAAA;EACA,4BAAA;EACA,YAAA;AAPd;AAWU;EACE,kBAAA;EACA,WAAA;EACA,QAAA;AATZ;AAYU;EACE,yBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AAVZ;AAaU;EACE,qBAAA;AAXZ;AAaY;EACE,qBAAA;EACA,4BAAA;EACA,mBAAA;EACA,8BAAA;AAXd;AAIU;EAUE,mBAAA;AAXZ;AAjDQ;EA8DE,sCAAA;EACA,oCAAA;AAVV;AAWU;EACE,oCAAA;EACA,uCAAA;AATZ;;AAgBA;EACE,iBAAA;EACA,eAAA;AAbF;AAcE;EACE,4BAAA;AAZJ;AAcE;EACE,WAAA;EACA,gBAAA;EACA,eAAA;AAZJ","sourcesContent":[".pricing {\n  .container-fluid {\n    .row {\n      .pricing-box {\n        position: relative;\n\n        .card {\n          padding: 15px;\n          border: none;\n          border-radius: 12px;\n          .card-body {\n            .card-title {\n              color: var(--subscribe-text);\n              font-weight: 600;\n            }\n\n            span {\n              font-size: 2rem;\n              color: var(--subscribe);\n            }\n\n            .text {\n              font-size: 3rem;\n              color: var(--subscribe);\n            }\n\n            .month {\n              color: var(--subscribe);\n            }\n\n            .type {\n              font-size: 1.2rem;\n              color: var(--subscribe-text);\n            }\n\n            .active {\n              color: var(--subscribe);\n              background-color: transparent;\n              font-size: 1.2rem !important;\n              border: none;\n            }\n          }\n\n          .icon-option {\n            position: absolute;\n            right: 15px;\n            top: 13%;\n          }\n\n          .ant-btn-default {\n            border-color: transparent;\n            color: var(--subscribe);\n            background: #f6fafd;\n            font-size: 1rem;\n          }\n\n          .button {\n            transition: 0.5s ease;\n\n            &:hover {\n              transition: 0.5s ease;\n              background: var(--subscribe);\n              color: var(--white);\n              border-color: var(--subscribe);\n            }\n\n            margin-bottom: 10px;\n          }\n          box-shadow: 0 0 3px rgba(0, 0, 0, 0.1);\n          transition: 0.4s box-shadow ease-out;\n          &:hover {\n            transition: 0.4s box-shadow ease-out;\n            box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n          }\n        }\n      }\n    }\n  }\n}\n.payment-card {\n  min-height: 111px;\n  cursor: pointer;\n  &.active {\n    border-color: var(--primary);\n  }\n  .payment-icon {\n    width: 100%;\n    min-height: 42px;\n    font-size: 28px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
